import { type Context, createContext } from 'react';

const StatusAnnouncementProviderContext: Context<boolean> = createContext(false);

export default StatusAnnouncementProviderContext;
